import { DocumentType } from '@nemuru-eng/js-api-client';

import { isNieDocumentType } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/utils/nieDocumentTypes.utils';
import { useMerchantPosContext } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/_shared/contexts/MerchantPosContext';

export const useShowMerchantPosNieDataFields = (documentType: DocumentType | undefined | null): boolean => {
  const { paymentMethodDetailEntity } = useMerchantPosContext();

  return paymentMethodDetailEntity.requiresNieData() && isNieDocumentType(documentType ?? undefined);
};
